import { memo } from 'react';

import Typography from 'components/UI/Typography/Typography';

import styles from './Banner.module.scss';

const Banner = () => (
  <div className={styles.root}>
    <Typography type="heading-md" weight="semibold" color="white">
      B2B Reward System
    </Typography>
    <Typography color="white">
      Grow your business together with Evoplay!
    </Typography>
  </div>
);

export default memo(Banner);
